import React from 'react';
import withAuthorisation from '../../components/auth/WithAuthorisation';
import { Link } from 'react-router-dom';

const SuccessInvalidData = (props) => {
  return (
    <main className="govuk-main-wrapper govuk-main-wrapper--l">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-two-thirds">
          <div className="govuk-panel govuk-panel--confirmation">
            <h1 className="govuk-panel__title">Data upload complete</h1>
            <div className="govuk-panel__body">
              <p>Your Suspicious Activity Report ID</p>
              <strong id="data-uuid" data-test="success-uuid">
                {props.uuid}
              </strong>
            </div>
          </div>
          <div className="govuk-warning-text">
            <span className="govuk-warning-text__icon" aria-hidden="true">!</span>
            <strong className="govuk-warning-text__text">
              <span className="govuk-visually-hidden">Warning</span>
              <p data-test="success-invalid-data">{props.invalidData}</p>
            </strong>
          </div>
          <p
            className="govuk-body"
            data-test="success-body"
            style={{ fontSize: '23px' }}
          >
            You can check the status of your data submission using the ID given
            above in{' '}
            <Link
              to="previous-uploads"
              className="govuk-link"
              data-test="prev-upload-link"
            >
              previously uploaded reports
            </Link>
            .
          </p>
          <p className="govuk-body" data-test="contact-email-address">
            If you have any questions or need support, contact the team at{' '}
            <a
              href="mailto:ChemicalReportingTeam@homeoffice.gov.uk"
              data-test="upload-contact-1-link"
            >
              ChemicalReportingTeam@homeoffice.gov.uk
            </a>
          </p>
          <a href="home" className="govuk-link">
            Return to the home page.
          </a>
        </div>
      </div>
    </main>
  );
};

const SuccessWithAuth = withAuthorisation({ forwardUrl: '/success-invalid-data' })(SuccessInvalidData);
export { SuccessWithAuth as SuccessInvalidData };
